export enum WidgetDataHooks {
  MAIN_CONTAINER = 'widget-main-container',
  GLOBAL_SPINNER = 'global-spinner',
  SUSPENSE_GLOBAL_SPINNER = 'suspense-global-spinner',
}
